export const loginWithRedirectParams = {
  audience: process.env.REACT_APP_AUTH_AUDIENCE,
  scope: process.env.REACT_APP_AUTH_SCOPE,
};

export async function getAccessToken(auth0Client, scope) {
  const params = {
    audience: process.env.REACT_APP_AUTH_AUDIENCE,
    scope: scope || process.env.REACT_APP_AUTH_SCOPE,
  };

  try {
    return await auth0Client.getTokenSilently(params);
  } catch (error) {
    if (error.error === 'consent_required' || error.error === 'login_required') {
      await auth0Client.loginWithRedirect({
        ...loginWithRedirectParams,
        prompt: 'consent',
      });
      return null;
    }
    throw error;
  }
}
